<script lang="ts" setup>
import { useItemStore } from "@/itemStore";
import type { Term } from "@/itemStore";
import ButtonElement from "@/components/ButtonElement.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  taxonomy: string;
}>();

const itemStore = useItemStore();
const { t } = useI18n();

const all = { id: 0, slug: "", name: t("all"), order: 0, children: [] } as Term;
</script>

<template>
  <ButtonElement v-if="itemStore.settings.filterRadio" :term="all" :taxonomy="props.taxonomy" />
  <ButtonElement
    v-for="term in itemStore.getTerms(props.taxonomy)"
    :key="term.slug"
    :term="term"
    :taxonomy="props.taxonomy"
  />
</template>
